<template>
  <div
    class="drill-tags drilltags"
    tabindex="1"
    @keydown.esc="handleOutsideClick()"
    @keydown.enter="confirm()"
    @keydown.up="handleArrow(-1)"
    @keydown.down="handleArrow(1)"
  >
    <div class="drilltags_top">
      <slot name="anyall">
        <div
          class="f-center text-medium line-height_1 clr-grey z-index_4 mr-auto"
          style="gap: 0.05rem; padding: 0 0.5rem 0.25rem 0.5rem"
          data-gwmenu="noclose"
        >
          {{ $t('anyall_tags_switch.match') }}
          <UnSwitcherNew
            v-if="hasAnyAll"
            trigger="click"
            :options="anyAllOptions"
            :tab="anyAllSelected.payload"
            :isInside="true"
            :hasOpener="true"
            :closeOnContentClick="true"
            style="--uns-opener-padding: 0 1.25rem 0 0.25rem"
            swKey="sw_range_content_hero"
            @click="
              item => {
                $emit('update:anyall', item.payload)
              }
            "
          >
            <template #selected>
              <div
                class="clr-grey"
                v-html="anyAllSelected.text"
              ></div>
            </template>
          </UnSwitcherNew>
        </div>
      </slot>

      <div class="drilltags_top_inner gw_input_wrapper">
        <div
          v-if="selectedTags.length"
          class="drilltags_top_inner_selected"
        >
          <div
            v-for="tag in selectedTags"
            :key="tag.id"
            class="gw_btn gw_btn_tag tagdrill"
            :style="`--clr-back:${tag.color_hex};flex-shrink: 1; --z-index-hover:2`"
            @click="$emit('click:tag', tag)"
          >
            <div
              class="truncate"
              :title="tag.name"
            >
              {{ tag.name }}
            </div>

            <div
              data-gwmenu="noclose"
              class="mdi ml-1 icon_btn pa-1 mdi-close text-normal csst csst_nm"
            ></div>
          </div>
        </div>
        <input
          ref="input"
          class="drilltags_input"
          :value="l_tag.name"
          type="text"
          spellcheck="false"
          style="
            --input-padding: 0 0.25rem;
            --input-border-width: 1px;
            --input-border-radius: 4px;
            --input-height: 2rem;
          "
          @input="handleInput"
        />
      </div>
    </div>
    <div class="drilltags_bottom">
      <div class="drilltags_options">
        <div
          v-if="hasEdit"
          class="text-small clr-grey mb-1 pl-1"
          v-html="$t('messages.select_or_create_option')"
        />
        <div
          v-if="!hasEdit && nameFilteredTags.length"
          class="text-small clr-grey mb-1 pl-1"
          v-html="$t('messages.select_option')"
        />
        <div
          v-if="!hasEdit && !l_allTags.length"
          class="text-small clr-grey pl-1"
          v-html="$t('messages.no_tags_yet')"
        />
        <div
          v-else-if="!hasEdit && !nameFilteredTags.length"
          class="text-small clr-grey pl-1"
          v-html="$t('messages.no_results')"
        />
        <div
          v-for="tag in nameFilteredTags"
          :key="tag.id"
          class="drilltags_options_option gw_btn gw_btn_small gw_btn_text"
          :class="{ 'gw_btn_hovered z-index_2': s_tag.id === tag.id }"
          @click="handleClickNameFilteredTag(tag)"
        >
          <div
            class="gw_btn gw_btn_tag drilltags_list_tag gw_btn_nohover mr-auto tagdrill"
            :style="`--clr-back:${tag.color_hex};flex-shrink: 1`"
          >
            <div
              class="truncate"
              :title="tag.name"
            >
              {{ tag.name }}
            </div>
            <div
              v-if="tagIds.includes(tag.id)"
              data-gwmenu="noclose"
              class="mdi ml-1 icon_btn pa-1 mdi-close text-normal csst csst_nm"
            ></div>
          </div>

          <GwMenu
            v-if="hasEdit && !tag.public"
            ref="gwmenu"
            :isInside="true"
            :ignoreDataGwmenu="true"
            class="ml-auto"
            placement="top"
            :flOptions="{ offset: 0, padding: 0 }"
            @click.stop
          >
            <template #opener>
              <div
                :ref="tag.id"
                class="ml-1 text-semi-large icon_btn pa-1 clr-grey mdi mdi-dots-vertical"
                @click="updateTag(tag)"
              ></div>
            </template>
            <template #default="{ methods }">
              <TagManager
                class="gw_menu"
                :tagName="s_tagUpdate.name"
                :color_hex="s_tagUpdate.color_hex"
                :colors="clrs"
                :errorSameNameexists="!!errorSameNameexists"
                :inputAutofocus="inputAutofocus"
                @delete="deleteSTag()"
                @update:name="
                  name => {
                    s_tagUpdate = { ...s_tagUpdate, name }
                  }
                "
                @update:color_hex="
                  color_hex => {
                    s_tagUpdate = { ...s_tagUpdate, color_hex }
                  }
                "
                @confirm="methods.toggleOpen(false), confirm()"
              />
            </template>
          </GwMenu>
        </div>
      </div>
      <div
        v-if="hasEdit && l_tag.name && l_tag.name !== nameMatchTag.name"
        class="drilltags_new bt-grey"
      >
        <div class="drilltags_clrs">
          <div
            v-for="hex in clrs"
            :key="hex"
            class="drilltags_tag_clrsr_box gw_btn tagdrill"
            :style="`
            --clr-back:${hex};
            --brighten-hover: 0.35;
            --height:auto;
          `"
            @click="setHex(hex)"
          >
            <i
              v-if="l_tag.color_hex === hex"
              class="mdi mdi-check text-normal line-height_1 position-absolute"
            ></i>
          </div>
        </div>
        <div class="d-flex w-100 mt-1">
          <div
            class="no-events my-auto mr-auto gw_btn gw_btn_tag drilltags_list_tag gw_btn_nohover tagdrill"
            :style="`--clr-back:${l_tag.color_hex}; flex-shrink: 1;`"
          >
            <span
              class="truncate"
              :title="l_tag.name"
            >
              {{ l_tag.name }}
            </span>
          </div>
          <div
            class="gw_btn gw_btn_primary ml-2"
            data-gwmenu="noclose"
            @click="confirm"
          >
            {{ $t('btn.confirm') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import TagManager from '@/components/TagsManager/TagManager'
import GwMenu from '@/components/lib/GwMenu'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TagsManager',
  components: {
    TagManager,
    GwMenu,
    UnSwitcherNew,
  },
  mixins: [float_mix],
  props: {
    tagType: { required: true, type: String },
    allTags: Array,
    tagIds: { type: Array, default: () => [] },
    inputAutofocus: Boolean,
    anyAll: { default: () => 'some' },
    hasAnyAll: { type: Boolean, default: true },
    hasEdit: { type: Boolean, default: true },
    handleUpdateProps: Object, // used in drills
    // To get rid of `@click` TS error, we don't define this as an emit (that would override default event) but allow it as a prop
    onClick: Function,
  },
  emits: ['update:anyall', 'click:tag', 'click:clear', 'click:outside'],
  data() {
    this.clrs = [
      '#F25C57',
      '#E97852',
      '#E5B466',
      '#EBCB44',
      '#B1D14D',
      '#569976',
      '#5ABEB9',
      '#8DCAC7',
      '#3761BE',
      '#6964EC',
      '#A05BCD',
      '#EF99EB',
    ]
    this.lTag = {
      id: null,
      name: '',
      color_hex: this.clrs[Math.floor(Math.random() * (this.clrs.length - 1))],
    }
    return {
      // open: false,
      // updateSTag: false,
      l_tag: { ...this.lTag },
      s_tag: { ...this.lTag },
      s_tagUpdate: { ...this.lTag },
      canDelete: false,
    }
  },
  mounted() {
    this.focusInput()
  },
  methods: {
    clearAll() {
      this.$emit('click:clear')
      this.reset()
    },
    handleClickNameFilteredTag(tag) {
      this.$emit('click:tag', tag)
      this.reset()
    },
    handleInput(e) {
      const name = e.target.value.slice(0, 256)
      const filteredMatchTag = this.l_allTags.find(i => i.name === name) || {}
      this.l_tag = {
        ...this.l_tag,
        ...filteredMatchTag,
        name,
      }
      // console.log(filteredMatchTag)
      if (filteredMatchTag.id) {
        this.s_tag = { ...filteredMatchTag }
      } else {
        this.s_tag = {}
      }
    },
    reset() {
      this.l_tag = { ...this.lTag }
      this.s_tag = { ...this.lTag }
      this.s_tagUpdate = { ...this.lTag }
      this.canDelete = false
      this.focusInput()
    },
    setHex(hex) {
      this.l_tag.color_hex = hex
      this.focusInput()
    },
    handleOutsideClick(e) {
      if (e?.target?.classList?.contains('drill_row_tags_opener')) return

      if (this.s_tagUpdate.id) {
        this.s_tagUpdate = { ...this.lTag }
        this.focusInput()
        return
      }
      this.open = false
      this.blurInput()
      this.$emit('click:outside', e)
    },
    updateTag(tag) {
      this.s_tag = { ...tag }
      this.s_tagUpdate = { ...tag }
    },
    focusInput(ref = 'input') {
      if (!this.inputAutofocus) return
      if (this.$refs[ref]) {
        this.$refs[ref].scrollIntoView()
        this.$refs[ref].focus()
      }
    },
    blurInput(ref = 'input') {
      if (this.$refs[ref]) {
        this.$refs[ref].blur()
      }
    },
    setScrollListScrollTop(n) {
      if (this.$refs.tagslist) {
        nextTick(() => {
          this.$refs.tagslist.scrollTop = n
        })
      }
    },

    confirm() {
      // if (this.$refs.gwmenu) {
      // this.$refs.gwmenu.forEach(el => el.toggleOpen(false))
      // }
      if (this.s_tagUpdate.id) {
        this.postPatchTag(this.s_tagUpdate, 'PATCH')
        return
      }
      if (this.s_tag.id) {
        this.handleClickNameFilteredTag(this.s_tag)
        return
      }
      this.postPatchTag(this.l_tag, 'POST')
    },
    postPatchTag(tag, method) {
      if (!tag.name || tag.length > 256) return
      if (tag.name.length > 256) return
      if (this.errorSameNameexists && method === 'PATCH') return
      const item = {
        id: tag.id,
        color_hex: tag.color_hex,
        name: tag.name.trim(),
      }
      this.$store.dispatch('tags_set_tag', {
        item,
        method,
        hasMessage: false,
        // drills: this.drills,
        hasExpectedResponse: method === 'PATCH',
        tagType: this.tagType,
        handleUpdateProps: this.handleUpdateProps,
      })
      if (method === 'POST') {
        this.setScrollListScrollTop(0)
      }
      this.reset()
    },
    deleteSTag() {
      this.$store.dispatch('tags_set_tag', {
        item: this.s_tag,
        method: 'DELETE',
        hasMessage: false,
        hasExpectedResponse: true,
        tagType: this.tagType,
      })
      this.reset()
    },

    handleArrow(n) {
      if (this.s_tagUpdate.id) return
      if (!this.nameFilteredTags.length) return
      const opts = this.nameFilteredTags
      let idx = opts.findIndex(i => i.id === this.s_tag.id)
      idx = idx === -1 ? 0 : idx + n
      idx = idx === -1 ? opts.length - 1 : idx
      this.s_tag = opts[idx] || opts[0]
    },
  },
  computed: {
    l_allTags() {
      return this.allTags ? this.allTags : this.$store.getters.tags_get_all_tags(this.tagType)
    },
    anyAllOptions() {
      return [
        { text: this.$t('anyall_tags_switch.any_tag'), payload: 'any' },
        { text: this.$t('anyall_tags_switch.all_tags'), payload: 'all' },
      ]
    },
    anyAllSelected() {
      return this.anyAllOptions.find(i => i.payload === this.anyAll) || this.anyAllOptions[0]
    },
    errorSameNameexists() {
      return this.l_allTags.find(i =>
        this.s_tagUpdate.id === i.id ? false : i.name === this.s_tagUpdate.name,
      )
    },
    nameFilteredTags() {
      return this.l_allTags.filter(i =>
        i.name.toLowerCase().includes(this.l_tag.name.toLowerCase()),
      )
    },
    nameMatchTag() {
      return this.l_allTags.find(i => i.name === this.s_tag.name) || {}
    },
    selectedTags() {
      return this.tagIds.map(id => this.l_allTags.find(ee => ee.id === id)).filter(i => i)
    },

    apiCall() {
      // return {
      // error: true,
      // status: 404,
      // loading: true,
      // }
      return this.$store.getters.api_get('api_poker_drill_tags')
    },
  },
  watch: {
    tagIds() {
      this.reset()
    },
  },
}
</script>
<style lang="scss" scoped>
.drilltags {
  // &_mobile_close {
  //   display: none;
  // }
  width: clamp(12rem, 16rem, 100vw);
  overflow: hidden;
  border-radius: 4px;
  max-height: var(--vh-6);

  // border: solid 1px var(--clr-black-3);
  // background: var(--clr-black-1);
  &_top {
    padding: 0.5rem 0;
    background: var(--clr-black-2);
    display: flex;
    flex-direction: column;
    &_inner {
      width: 100%;
      gap: 0.25rem;
      max-height: 12rem;
      overflow-y: auto;
      position: relative;
      padding: 0 0.5rem;
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
      &_selected {
        max-width: 100%;
        padding: 0 2rem 0 0;
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
      }
    }
  }
  &_clear-all {
    position: absolute;
    right: 4px;
    top: 0.325rem;
    padding: 2px;
  }
  &_options {
    padding: 0.5rem;
    background: var(--clr-black-1);
    display: flex;
    max-height: clamp(12rem, 22rem, 88vh);
    overflow-y: auto;
    flex-direction: column;
    gap: 0.125rem;
    &_option {
      position: relative;
      z-index: 1;
    }
  }
  &_new {
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.5rem;
    background: var(--clr-black-1-3);
  }
  &_clrs {
    width: 100%;
    display: grid;
    // gap: 0.125rem;
    // height: 1.25rem;
    // height: 1.5rem;
    // grid-template-columns: repeat(12, 1fr);
    gap: 0.25rem;
    height: 4rem;
    grid-template-columns: repeat(6, 1fr);
    flex-shrink: 0;
    &_box {
      --clr-back: red;
      border-radius: 4px;
      background: var(--clr-back);
      padding: 0;
      height: auto;
    }
  }
}

@media screen and (max-width: 1023px) {
  .drilltags {
    // left: 50%;
    // margin-left: calc(100vw * -0.5);
    left: 0;
    width: 100vw;
    transition: 0.22s;
    // &_mobile {
    //   &_visible {
    //     bottom: calc(var(--glo-footer-height) + var(--safe-area-inset-bottom));
    //   }
    //   &_hidden {
    //     bottom: -100%;
    //   }
    //   &_close {
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //   }
    // }
  }
}
</style>
